import { SignToken } from '@ap/sign';

import { BrowserSignToken } from './tokens-browser.model';

export class TokensBrowserMapper {
    public static mapSignTokenToBrowserSignToken(signToken: SignToken): BrowserSignToken {
        switch (signToken) {
            case SignToken.DIGIPAS:
                return BrowserSignToken.DIGIPAS;
            case SignToken.NATIVE_APP:
                return BrowserSignToken.NATIVE_APP;
            default:
                return undefined;
        }
    }

    public static mapBrowserSignTokenToSignToken(browserSignToken: BrowserSignToken): SignToken {
        switch (browserSignToken) {
            case BrowserSignToken.DIGIPAS:
                return SignToken.DIGIPAS;
            case BrowserSignToken.NATIVE_APP:
                return SignToken.NATIVE_APP;
            default:
                return undefined;
        }
    }
}
